


















































































































import Vue from 'vue';
import store from '@/store';

import GetStartedNav from '@/components/getStarted/GetStartedNav.vue';

export default Vue.extend({
  components: {
    GetStartedNav
  },

  computed: {
    failed(): string[] {
      return store.state.getStarted.creationProcess.failed;
    },

    hasFailures(): boolean {
      return this.failed.length > 0;
    },

    newOrgId(): number | undefined {
      return store.state.getStarted.creationProcess.newOrgId;
    },

    continueOn(): boolean {
      return !!this.newOrgId;
    },

    userConflicts(): string[] {
      return store.state.getStarted.creationProcess.userConflicts;
    },

    hasConflicts(): boolean {
      return this.userConflicts.length > 0;
    }
  },

  methods: {
    async goToDashboard() {
      try {
        store.dispatch.auth.signInExistingFirebaseUser();

        await this.$router.push({
          name: 'Organization',
          params: { organizationId: `${this.newOrgId}` }
        });
      } catch (error) {
        // Re-directing will cause this to error.
        // And we always re-direct because this user isn't authorized in the
        // dashboard app (see router/index.js:160).
      }
    }
  }
});
